module.exports = __webpack_public_path__ + "static/media/back_to_school.fa54d7d6.svg";